import JustValidate from 'just-validate';
import { isEmailValid } from '../helpers/EmailValid';
import Popups from '../../../components/popups/popups';

class Form {
	constructor() {
		this.forms = document.querySelector('[data-popups-form-application]');
		this.email = this.forms.querySelector(
			'[data-popups-form-application-email]',
		);
		this.name = this.forms.querySelector('[data-popups-form-application-name]');
		this.cvlink = this.forms.querySelector('[data-file-uploader-input]');
		this.validator = new JustValidate('[data-popups-form-application]');

		this.fileInput = document.getElementById('file-input');
		this.fileList = document.querySelector('[data-file-uploader-list]');
		this.files = [];
		this.init();
		this.fileUploader();
	}
	init() {
		this.validator
			.addField('[data-popups-form-application-name]', [
				{
					rule: 'required',
					value: true,
				},
			])
			.addField('[data-popups-form-application-email]', [
				{
					rule: 'required',
					value: true,
				},
				{
					rule: 'function',
					validator: () => isEmailValid(this.email.value),
					errorMessage: false,
				},
			])
			.addField('[data-file-uploader-input]', [
				{
					rule: 'required',
					value: true,
				},
			])
			.onSuccess(() => {
				let formData = new FormData();
				formData.append('name', this.name.value);
				formData.append('email', this.email.value);
				formData.append('cvlink', this.cvlink.value);
				for (let i = 0; i < this.files.length; i++) {
					formData.append('uploadedDocs', this.files[i]);
				}

				fetch('/submitapp', {
					method: 'POST',
					body: formData,
				}).then(async (response) => {
					Popups.open('form-send');
					reset();
				});
				let reset = () => {
					this.name.value = '';
					this.email.value = '';
					this.cvlink.value = '';
					while (this.fileList.firstChild) {
						this.fileList.removeChild(this.fileList.lastChild);
					}
					this.files.length = 0;
					this.validator.addField('[data-file-uploader-input]', [
						{
							rule: 'required',
							value: true,
						},
					]);
				};
			});
	}
	fileUploader() {
		this.fileInput &&
			this.fileInput.addEventListener('change', (e) => {
				const files = e.target.files;

				for (const file of files) {
					this.files.push(file);
					const li = document.createElement('li');
					const fileName = document.createElement('span');
					fileName.classList.add('file-uploader__list-text');
					const deleteButton = document.createElement('button');
					deleteButton.classList.add('file-uploader__list-btn');

					fileName.textContent = file.name;

					li.appendChild(fileName);
					li.appendChild(deleteButton);
					this.fileList.appendChild(li);

					deleteButton.addEventListener('click', () => {
						li.parentNode.removeChild(li);
						this.files.splice(this.files.indexOf(file), 1);
						if (this.files.length == 0) {
							this.validator.addField('[data-file-uploader-input]', [
								{
									rule: 'required',
									value: true,
								},
							]);
						}
					});
				}
				if (this.files.length > 0) {
					delete this.validator.fields[3]; // remove validation
				}
				this.fileInput.value = '';
			});
	}
}

export default new Form();
